module.exports = __webpack_public_path__ + "media/images/es_419/chart_big-73cd99d44465f1e087606a132ed4d7d5.png";